<template>
  <div class="running_content">
    <div class="running_block">
      <div>
        <countTo
          class="running_count running_animation"
          :startVal="0"
          :endVal="form.days"
          :duration="3000"
        ></countTo>
        <span class="running_desc">天</span>
        <br />
        <span class="running_desc">安全生产运行</span>
      </div>
      <img :src="imgs" alt="" class="running_animation_one" />
    </div>
    <div class="running_block">
      <div>
        <countTo
          class="running_count running_animation"
          :startVal="0"
          :endVal="form.completionNum"
          :duration="3000"
        ></countTo>
        <span class="running_desc">单</span>
        <br />
        <span class="running_desc">总完成订单</span>
      </div>
      <img :src="imgs" alt="" class="running_animation_one" />
    </div>
    <div class="running_block">
      <div>
        <countTo
          class="running_count running_animation"
          :startVal="0"
          :endVal="form.num"
          :duration="3000"
        ></countTo>
        <span class="running_desc">件</span>
        <br />
        <span class="running_desc">总完成件数</span>
      </div>
      <img :src="imgs" alt="" class="running_animation_one" />
    </div>
    <div class="running_block">
      <div>
        <countTo
          class="running_count running_animation"
          :startVal="0"
          :endVal="form.userCount"
          :duration="3000"
        ></countTo>
        <span class="running_desc">人</span>
        <br />
        <span class="running_desc">累计产研结合人数</span>
      </div>
      <img :src="imgs" alt="" class="running_animation_one" />
    </div>
  </div>
</template>
<script>
import countTo from 'vue-count-to'
import { getWorkorderAllCompleteCount, getWorkorderAllCompleteDay, getUserCount } from '@/api/index'
export default {
  components: {
    countTo
  },
  data () {
    return {
      imgs: require('@/assets/imgs/icon02.png'),
      form: {
        num: 0,
        completionNum: 0,
        days: 0,
        userCount: 0
      }
    }
  },
  mounted () {
    this.getWorkorderAllCompleteCounts()
    this.getWorkorderAllCompleteDays()
    this.getUserCounts()
  },
  methods: {
    async getWorkorderAllCompleteCounts () {
      let result = await getWorkorderAllCompleteCount({})
      console.log(result)
      if (result.code == 200) {
        this.form = Object.assign({}, this.form, result.data)
      }
    },
    async getWorkorderAllCompleteDays () {
      let result = await getWorkorderAllCompleteDay({})
      console.log(result, 111)
      if (result.code == 200) {
        this.$set(this.form, 'days', result.data)
        console.log(this.form, 23232323)
      }
    },
    async getUserCounts () {
      let result = await getUserCount({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this.form, 'userCount', result.data)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.running_content {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  .running_block {
    width: 50%;
    text-align: center;
    .running_count {
      font-family: DIN;
      font-weight: bold;
      font-size: 22px;
      color: #ffffff;
      display: inline-block;
    }
    .running_desc {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }
    img {
      margin-top: -20px;
    }
  }
  .running_animation_one {
    animation: breathLamp 1s alternate infinite;
  }
  .running_animation {
    animation: breathLampScale 1.5s alternate infinite;
  }
}
@keyframes breathLamp {
  0% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@keyframes breathLampScale {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>